import React, { useState } from 'react';
import { Meteor } from 'meteor/meteor';
import { forEach, keyBy, map, set } from 'lodash';

import MapsList from '../../components/MapsList';
import { MAP_OPTIONS, MAP_TYPES } from '../../../api/Maps/Maps';

const { defaultMapCenter } = Meteor.settings.public;

const INITIAL_DATE_RANGE_START = '2020-01-01';
const INITIAL_DATE_RANGE_END = new Date().toISOString().slice(0, 10);
const INITIAL_BOUNDING_BOX = [
  [-180, -90],
  [180, 90]
];

const Maps = props => {
  const [timeFilterOn, changeTimeFilterOn] = useState(false);
  const [dateRangeStart, changeRangeStart] = useState(INITIAL_DATE_RANGE_START);
  const [dateRangeEnd, changeRangeEnd] = useState(INITIAL_DATE_RANGE_END);
  const timeFilterProps = {
    changeFilterOn: changeTimeFilterOn,
    changeRangeEnd,
    changeRangeStart,
    dateRangeEnd,
    dateRangeStart,
    filterOn: timeFilterOn,
    humanValue: 'Date',
    name: 'date'
  };

  const [locationFilterOn, changeLocationFilterOn] = useState(false);
  const [boundingBox, changeBoundingBox] = useState(INITIAL_BOUNDING_BOX);
  const locationFilterProps = {
    boundingBox,
    changeBoundingBox,
    changeFilterOn: changeLocationFilterOn,
    defaultLocation: defaultMapCenter,
    filterOn: locationFilterOn,
    humanValue: 'Location',
    name: 'location'
  };

  const typeFilters = keyBy(
    map(
      [...map(MAP_TYPES.properties), ...map(MAP_OPTIONS.properties)],
      ({ name, value, humanValue }) => ({
        filterOn: false,
        name: `type${name}`,
        value,
        humanValue
      })
    ),
    'name'
  );
  const typeFilterProps = { ...typeFilters };
  forEach(typeFilters, ({ name }) => {
    const [filterOn, changeFilterOn] = useState(false);
    set(typeFilterProps, `${name}.filterOn`, filterOn);
    set(typeFilterProps, `${name}.changeFilterOn`, changeFilterOn);
  });

  const tagsFilterProps = {
    name: 'tags',
    tagsInFilter: []
  };

  const filterOptions = {
    tags: tagsFilterProps,
    time: timeFilterProps,
    location: locationFilterProps,
    ...typeFilterProps
  };

  return <MapsList filterOptions={filterOptions} {...props} />;
};

Maps.defaultProps = {};

Maps.propTypes = {};

export default Maps;
